import {
  buildNutritionEntityDuplicateName,
  getNutritionEntityDisplayName,
  getNutritionEntityDisplayNameFromSources,
  resolveNutritionEntityName,
} from "../shared/nutritionEntityNameUtils";

export function resolveNutritionPlanName(...sources) {
  return resolveNutritionEntityName(...sources);
}

export function getNutritionPlanDisplayName(planLike, language = "en") {
  return getNutritionEntityDisplayName("plan", planLike, language);
}

export function getNutritionPlanDisplayNameFromSources(
  sources = [],
  language = "en",
) {
  return getNutritionEntityDisplayNameFromSources("plan", sources, language);
}

export function buildNutritionPlanDuplicateDisplayName(
  sources = [],
  language = "en",
) {
  return buildNutritionEntityDuplicateName("plan", sources, language);
}
